<!-- 热门话题 -->
<template>
<div class="hot-subject">
    <div class="title">
        <img :src="require('./assets/title.png')" alt="">
        <a :href="'/detail/d71ee60f-b64d-4ad7-8070-373b3cf984a4?topic=recycle'|hostBuild('forum')" target="_blank" class="join-enter">参与讨论赢红包/购物卡</a>
    </div>
    <div class="list-cont">
        <div class="item" v-for="(item,index) in list" :key="index" >
            <div class="index">{{index+1}}.</div>
            <div class="flex-cont"><a :href="'/publish/edu?subject=bd0f46d4-687b-466b-b880-21abd53cd5fb'|hostBuild('forum')" target="_blank"> {{item.title}}</a></div>
            <a class="write-enter" :href="'/publish/edu?subject=bd0f46d4-687b-466b-b880-21abd53cd5fb'|hostBuild('forum')" target="_blank">
                <img :src="require('./assets/write.png')" alt="">
                <span>我也来说说...</span>
            </a>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name:'HotSubject',
    data(){
        return {
            list:[
                {title:'孩子要开学了，你最想对TA说…'},
                {title:'神兽终于归笼了，TA出门的背影好可爱'},
                {title:'晒晒你为孩子开学准备的物品清单'},
                {title:'聊聊你的学生时代印象深刻的事情'},
            ]
        }
    }
}
</script>
<style lang="less" scoped>
.hot-subject{
    padding:10px 20px 20px; background: url(./assets/blk-bg.png) no-repeat center top;margin: 0 15px 20px; border-radius: 20px;
    .title{
       
        display: flex; align-items: center;
        height: 48px;
        img{width:100px}
        a{margin-left: 15px; font-size: 16px; line-height: 22px; color: #BD5024; text-decoration: underline; }
    }
    .list-cont{
        background: #fff; border-radius: 10px; overflow: hidden;
        .item{
            display: flex; align-items: center; margin:  20px; line-height: 24px;
            .index{width: 24px; height: 24px; text-align: center; line-height: 24px; background: url(./assets/txt-bg.png) no-repeat center center ; color: #1c1c1c; margin-right: 10px;}
            .flex-cont{flex:1;overflow: hidden;text-overflow: ellipsis;
                a{white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                    &:hover{color: #FF8253;}
                }
            }
            .write-enter{
                display: flex; align-items: center; font-size: 14px; color: #FF8253; margin-left: 5px;
                img{margin-right: 5px;}
                span{display: none;}
            }
        }
    }
}


@media screen and (min-width:768px){
    .hot-subject{max-width: 800px; margin: 0 auto 20px; padding: 20px;
        .title{
            background: url(./assets/bg-ico.png) no-repeat right bottom;height: 63px;
            img{width: 140px;}
        }
        .list-cont{

            .write-enter{
                span{display: inline-block !important;}
            }
        }
    }
    
}
</style>